/**
 * Canonical public visibility filter for activities.
 *
 * Rules (shared by Landing + Explore):
 *  - timing_mode = 'open' → visible while end_date is null OR end_date >= now
 *    (null end_date means open indefinitely; only past if explicit end has passed)
 *  - timing_mode = 'anytime' → always visible if public (legacy alias)
 *  - timing_mode = 'season'  → visible while end_date is null OR end_date >= now
 *  - timing_mode = 'date_time' → visible only if cutoff > now
 *    (cutoff = end_date if set, otherwise start_date)
 *
 * This mirrors the timeBucket logic but answers the question
 * "should this appear in a default public list?" rather than
 * "which tab does it belong in?"
 */

export function isActivityPubliclyVisible(
  event: {
    timingMode: string;
    startDate?: string | null;
    endDate?: string | null;
  },
  now: Date = new Date(),
): boolean {
  if (event.timingMode === 'anytime') return true;

  if (event.timingMode === 'open') {
    return !event.endDate || new Date(event.endDate) >= now;
  }

  if (event.timingMode === 'season') {
    // Visible while end_date is null or hasn't passed
    return !event.endDate || new Date(event.endDate) >= now;
  }

  // date_time: use end_date as cutoff if available, else start_date
  const cutoffRaw = event.endDate ?? event.startDate;
  if (!cutoffRaw) return false; // No date at all → not visible
  return new Date(cutoffRaw) > now;
}
